import * as React from "react";

export function HomeIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 19 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M.868 7.635c0 .3.234.586.63.586.205 0 .373-.11.527-.234l7.331-6.153c.162-.146.36-.146.52 0l7.332 6.153c.147.124.315.234.52.234.344 0 .623-.212.623-.564a.599.599 0 00-.227-.498l-2.051-1.728V2.5c0-.322-.205-.527-.528-.527h-.783c-.315 0-.528.205-.528.527v1.384L10.5.75C9.957.29 9.283.29 8.734.75L1.102 7.16a.613.613 0 00-.234.475zm2.285 6.534c0 1.018.615 1.618 1.648 1.618h9.631c1.033 0 1.64-.6 1.64-1.619v-5.8l-6.02-5.047c-.278-.234-.608-.227-.879 0l-6.02 5.047v5.8zm8.342.439h-3.78V9.767c0-.337.228-.557.565-.557h2.659c.336 0 .556.22.556.557v4.84z"
        fill="currentColor"
      />
    </svg>
  );
}
